export interface Progress {
  played: number;
  total: number;
}

export const CompetitionStatus = /* @__PURE__ */ Object.freeze({
  DRAFT: 'Draft',
  ACTIVE: 'Active',
  COMPLETE: 'Complete',
});
export type CompetitionStatus =
  (typeof CompetitionStatus)[keyof typeof CompetitionStatus];

export interface Competition {
  status: CompetitionStatus;
  progress?: Progress;
  /**
   * Player ID of the winner
   */
  winner?: string;
  /**
   * Player ID of the winner
   */
  runnerUp?: string;
}

export interface RoundRobinCompetition extends Competition {
  divisions: number;
  entrants: number;
}

export const Format = {
  EightBall: '8',
  NineBall: '9',
} as const;
export type Format = (typeof Format)[keyof typeof Format];

export function isFormat(value: unknown): value is Format {
  return Object.values(Format).some((format) => format === value);
}

export const Elimination = {
  Single: 'S',
  Double: 'D',
} as const;
export type Elimination = (typeof Elimination)[keyof typeof Elimination];

export function isElimination(value: unknown): value is Elimination {
  return Object.values(Elimination).some(
    (elimination) => elimination === value,
  );
}

export interface KnockoutCompetition extends Competition {
  elimination: Elimination;
  entrants: string[];
}

export function isRoundRobin(
  competition: Competition,
): competition is RoundRobinCompetition {
  return 'divisions' in competition;
}

export function isKnockout(
  competition: Competition,
): competition is KnockoutCompetition {
  return 'elimination' in competition;
}

export function isValidTransition(
  from: CompetitionStatus,
  to: CompetitionStatus,
) {
  const transitions: Partial<Record<CompetitionStatus, CompetitionStatus>> = {
    [CompetitionStatus.DRAFT]: CompetitionStatus.ACTIVE,
    [CompetitionStatus.ACTIVE]: CompetitionStatus.COMPLETE,
  };
  return transitions[from] === to;
}
